const englishTraduction = {
    titleHome : 'Home',
    titleDoctor : 'Doctors',
    scheduleNav : 'Monday-friday',
    mainTitle: 'Your medical consultations in Bonnevoie',
    mainParagraph1 : 'The Medical Center of Bonnevoie welcomes you from Monday to Friday from 8am to 6pm.',
    mainParagraph2 : 'The Center offers consultations provided by our four general practitioners and one specialist in internal medecine only by appointment.',
    mainParagraph3 : '',
    mainParagraph31 : 'You can send your prescription renewal request by email: ',
    mainParagraph32 : 'Your request will be processed as soon as possible, generally within one business day. You will receive a confirmation email when the prescription is ready.',
    mainParagraph4 : 'We also have a Medical Analysis Laboratory Ketterthill open without appointment from Monday to Friday from 7 to 10am.',
    mainButton : "Consult doctors' schedules",
    doctorTitle : 'Our doctors',
    doctorAvailabilities : 'View availabilities',
    drObertinLanguages : 'Spoken languages : french , english , german , luxembourgish',
    drBarretDeGassartLanguages : 'Spoken languages : french , english',
    drWeberLanguages : 'Spoken languages : french , english , german , luxembourgish',
    drKrombachLanguages : 'Spoken languages : english , german , luxembourgish',
    drDuReauLanguages : 'Spoken languages : ',
    appointment : 'Only by appointment',
    contactTitle: 'Contact & access',
    mainTitleAnnexe: 'Your medical consultations in Bonnevoie "Annexe"',
    mainParagraph1Annexe : 'The Medical Center of Bonnevoie welcomes you from Monday to Friday from 8am to 6pm.',
    mainParagraph2Annexe : 'The Center offers consultations provided by our four general practitioners and one specialist in internal medecine only by appointment.',
    mainParagraph3Annexe : '',
    mainParagraph31Annexe : 'You can send your prescription renewal request by email: ',
    mainParagraph32Annexe : 'Your request will be processed as soon as possible, generally within one business day. You will receive a confirmation email when the prescription is ready.',
    mainParagraph4Annexe : 'We also have a Medical Analysis Laboratory Ketterthill open without appointment from Monday to Friday from 7 to 10am.',
}

export default englishTraduction